import { render } from "./FeaturedProjects.vue?vue&type=template&id=547507f1&scoped=true"
import script from "./FeaturedProjects.vue?vue&type=script&lang=js"
export * from "./FeaturedProjects.vue?vue&type=script&lang=js"

import "./FeaturedProjects.vue?vue&type=style&index=0&id=547507f1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-547507f1"]])

export default __exports__